// @flow

import { type UserInputValidationError, VALID } from '@tectonics/prs/validation';

export function validateColombianState(stateValue: string): ?UserInputValidationError {
  return stateValue ? VALID : { id: 'empty' };
}
